import type {
  ILocationRepository,
  ProjectLocationTabCategoryOptions,
} from "../repositories/ILocationRepository.js";

interface Deps {
  locationRepository: ILocationRepository;
}

export function createListProjectLocationTabCategoriesUseCase({ locationRepository }: Deps) {
  return async function listProjectLocationTabCategories(
    options: ProjectLocationTabCategoryOptions,
  ): Promise<string[]> {
    return locationRepository.listProjectLocationTabCategories(options);
  };
}
